export const QueryKeys = {
  mcq_exams: ["mcq_exams"],
  mcq_question: ["mcq_question"],
  mcq_exam_user: ["mcq_exam_user"],
  subjective_mega_exam: ["subjective_mega_exam"],
  all_users: ["all_users"],
  add_sub_marks: ["add_sub_marks"],
};
